exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge.badge-pill.eshop {\n  background-color: orange; }\n  .badge.badge-pill.eshop a {\n    text-decoration: none;\n    color: white; }\n\n.badge.badge-pill.confirmed {\n  background-color: #dc3545; }\n\n.badge.badge-pill.dispatched {\n  background-color: coral; }\n\n.badge.badge-pill.in_dispatch {\n  background-color: #9d00db; }\n\n.badge.badge-pill.returned {\n  background-color: lightgreen; }\n\n.badge.badge-pill.canceled {\n  background-color: #000; }\n\n.badge.badge-pill.handed {\n  background-color: #b85d5d; }\n\n.badge.badge-pill.picked {\n  background-color: #3a7db9; }\n\n.badge.badge-pill.waitingAccept {\n  background-color: #17a2b8; }\n\n.badge.badge-pill.received {\n  background-color: #28a745; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/SharedModule/ContractStateComponent/contract-state.component.scss
// module id = ../../../../../src/SharedModule/ContractStateComponent/contract-state.component.scss
// module chunks = main